import React from 'react';
import {TextButton, TextButtonPriority} from '@wix/wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {st, classes} from './Header.st.css';
import {useControllerProps} from '../Widget/ControllerContext';
import {CheckoutSlot} from '../CheckoutSlot';
import {SlotId} from '../../../domain/utils/slotId';
import {StoreNameAndLogo} from '../../../common/components/StoreNameAndLogo/StoreNameAndLogo';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../common/constants';
import {hexToRgb} from '../../../domain/utils/colors';

export enum HeaderDataHooks {
  ContinueShoppingButton = 'HeaderDataHooks.ContinueShoppingButton',
  Divider = 'HeaderDataHooks.Divider',
  OldDivider = 'HeaderDataHooks.OldDivider',
}

export const Header = ({dataHook}: {dataHook: string}) => {
  const localKeys = useLocaleKeys();
  const {
    isOneColumnView,
    checkoutSettingsStore: {checkoutSettings, checkoutContent},
    navigationStore: {continueShoppingUrl, clickOnContinueShopping, isContinueShoppingEnabled},
    slotsStore,
  } = useControllerProps();
  const {experiments} = useExperiments();
  const shouldApplyHeaderCustomizations = experiments.enabled(SPECS.CheckoutHeaderAdditionalCustomizationsCheckout);
  const checkoutUIRevampOrderSummary = experiments.enabled(SPECS.CheckoutUIRevampOrderSummary);

  const continueShoppingText = checkoutContent?.continueShoppingLink ?? localKeys.checkout.continue_shopping();
  const backgroundColor = checkoutSettings?.checkoutHeader?.backgroundFill?.color;
  const textColor = checkoutSettings?.checkoutHeader?.textColor;

  const headerStyle = shouldApplyHeaderCustomizations
    ? ({
        '--headerBackground': backgroundColor,
        '--headerTextColor': textColor,
        '--headerTextColor-rgb': hexToRgb(textColor),
      } as React.CSSProperties)
    : {};

  const getHeaderCheckoutSlotClassName = () => {
    if (isOneColumnView) {
      return classes.headerCheckoutSlotMobile;
    }
    return checkoutUIRevampOrderSummary ? classes.headerCheckoutSlot : classes.headerCheckoutSlotOld;
  };

  return (
    <div className={classes.header} style={headerStyle}>
      <div
        className={st(shouldApplyHeaderCustomizations ? classes.innerHeader : classes.innerHeaderOld)}
        data-hook={dataHook}>
        <StoreNameAndLogo
          continueShoppingUrl={continueShoppingUrl}
          clickOnContinueShopping={clickOnContinueShopping}
          logoUrl={checkoutSettings?.logoUrl}
          storeName={checkoutSettings?.storeName}
          checkoutHeader={checkoutSettings?.checkoutHeader}
          isOneColumnView={isOneColumnView}
        />
        {isContinueShoppingEnabled && (
          <TextButton
            as={'a'}
            className={
              shouldApplyHeaderCustomizations ? classes.continueShoppingButton : classes.continueShoppingButtonOld
            }
            data-hook={HeaderDataHooks.ContinueShoppingButton}
            href={continueShoppingUrl}
            onClick={() => clickOnContinueShopping()}
            priority={TextButtonPriority.link}>
            {continueShoppingText}
          </TextButton>
        )}
      </div>
      {!checkoutUIRevampOrderSummary && <div className={classes.divider} data-hook={HeaderDataHooks.OldDivider} />}
      {slotsStore && <CheckoutSlot className={getHeaderCheckoutSlotClassName()} slotId={SlotId.HeaderCheckoutSlot} />}
      {checkoutUIRevampOrderSummary && <div className={classes.divider} data-hook={HeaderDataHooks.Divider} />}
    </div>
  );
};
